import React from 'react';
import PropTypes from 'prop-types';
import styles from '../../css/components/forms/formHeadline.css';

function FormHeadline({ text }) {
	return (
		<h1 className={styles.headline}>{text}</h1>
	);
}

FormHeadline.propTypes = {
	text: PropTypes.string.isRequired,
};

export default FormHeadline;